import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export interface BottomReadyButtonProps {
  title?: string;
  subtitle?: string;
  ctaHref?: string;
  ctaText?: string;
}

export const BottomReadyButton = ({
  title = "Filter out irrelevant data to reduce costs.",
  subtitle,
  ctaText = "Get started with docs",
  ctaHref = "https://docs.mydecisive.ai/",
}: BottomReadyButtonProps) => {
  return (
    <Stack spacing={3} alignItems="center" mb={10} textAlign={"center"}>
      <Typography variant="h4">{title}</Typography>
      {subtitle && <Typography variant="body1">{subtitle}</Typography>}
      <Button
        href={ctaHref}
        variant="contained"
        rel="noopener noreferrer"
        target="_blank"
      >
        {ctaText}
      </Button>
    </Stack>
  );
};
